"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3FileHandlerClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const errors_1 = require("@deliverr/errors");
const axios_1 = require("axios");
const lodash_1 = require("lodash");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
const defaultConfig = {
    authEngine: core_auth_1.AuthEngine.UNKNOWN,
    baseURL: process.env.NON_COMPLIANCE_SERVICE_URL,
};
class S3FileHandlerClient extends base_client_1.ApiClient {
    constructor(config = {}, axiosConfig = {}) {
        if (!config.baseURL) {
            commons_logs_1.log.warn("baseURL is not configured");
        }
        if (config.authEngine === core_auth_1.AuthEngine.UNKNOWN) {
            throw new Error("authEngine for NonComplianceClient is not set");
        }
        if (config.authEngine === core_auth_1.AuthEngine.BASIC) {
            throw new Error("BASIC authEngine for NonComplianceClient is not supported");
        }
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            config.tokenRefreshFn = tokenHandler.getTokenFn();
        }
        super(Object.assign(Object.assign(Object.assign({}, defaultConfig), config), axiosConfig));
    }
    async uploadFile(file, onUploadProgress, headers) {
        const formData = new FormData();
        try {
            const presignedData = await this.getS3PresignedData({
                fileName: file.name,
                contentType: file.type,
            });
            Object.keys(presignedData.fields).forEach((key) => {
                formData.append(key, presignedData.fields[key]);
            });
            formData.append("file", file);
            await (0, axios_1.default)({
                url: presignedData.url,
                method: "POST",
                data: formData,
                headers,
                onUploadProgress,
            });
            return presignedData.fields.Key;
        }
        catch (error) {
            commons_logs_1.log.error("Error uploading file", error);
            throw await this.handleError(error);
        }
    }
    async batchDownload(ncCaseImagePaths) {
        try {
            const batchResponse = await this.post(`/v1/non-compliance/s3/batch-download`, {
                caseImagePaths: ncCaseImagePaths,
            });
            return batchResponse;
        }
        catch (error) {
            throw await this.handleError(error);
        }
    }
    async getS3FileUrl(filePath) {
        try {
            const presignedUrl = await this.get(`/v1/non-compliance/s3/download`, { filePath });
            return presignedUrl;
        }
        catch (error) {
            throw await this.handleError(error);
        }
    }
    async getS3File(filePath, redirect) {
        try {
            const presignedUrl = await this.get(`/v1/non-compliance/s3/download`, { filePath, redirect });
            return presignedUrl;
        }
        catch (error) {
            throw await this.handleError(error);
        }
    }
    async deleteFile(filePath) {
        try {
            return await this.delete("/v1/non-compliance/s3/delete", { filePath });
        }
        catch (error) {
            throw await this.handleError(error);
        }
    }
    async getS3PresignedData(req) {
        try {
            return await this.post("/v1/non-compliance/s3/upload", {
                fileName: req.fileName,
                contentType: req.contentType,
            });
        }
        catch (error) {
            throw await this.handleError(error);
        }
    }
    async handleError(error) {
        if (this.isAxiosNetworkError(error)) {
            return new errors_1.DeliverrError({
                code: errors_1.ApiError.NETWORK_ERROR,
                payload: this.getAxiosNetworkErrorPayload(error),
            });
        }
        const code = (0, lodash_1.get)(error, "response.data.error.code");
        const subcode = (0, lodash_1.get)(error, "response.data.error.subcode");
        const payload = (0, lodash_1.get)(error, "response.data.error.payload");
        if (code) {
            return new errors_1.DeliverrError({
                code,
                subcode,
                payload: payload || error.response,
            });
        }
        else {
            return new errors_1.DeliverrError({
                payload: error,
            });
        }
    }
    isAxiosNetworkError(error) {
        return error.message.toLowerCase() === "network error" || (0, lodash_1.get)(error, "response.status") === 504;
    }
    getAxiosNetworkErrorPayload(error) {
        return !error.response ? error : (0, lodash_1.pick)(error, ["status, headers, body"]);
    }
}
exports.S3FileHandlerClient = S3FileHandlerClient;
//# sourceMappingURL=S3FileHandlerClient.js.map